<div style="width: 700px; height: 700px;" data-cy="organizer-restore-container">
  <div class="section" style="display: flex; flex-direction: column; height: 100%; max-height: 100%;">
    <div class="section-header" style="flex-basis: 30px;">
      <div class="section-header-title" data-cy="organizer-restore-title">
        Select a folder to restore to
      </div>
      <div style="flex: 1;"></div>
    </div>
    <!--  MAIN AREA-->
    <div class="section-content" style="flex: 1; display: flex; overflow: hidden;" data-cy="organizer-restore-content">
      <div style="height: 100%; max-height: 100%; width: 100%; overflow-y: hidden; overflow-x: hidden; display: flex; flex-direction: column;" data-cy="organizer-restore-library-section">
        <span style="color: var(--tdo-primary); font-size: 22px;" data-cy="organizer-restore-library-label">Library</span>
        <div style="flex: 1; overflow-y: auto;" data-cy="organizer-restore-library-tree-container">
          @if (libraryTreeData.length > 0) {
            <tdo-tree #libraryTree
              (itemSelected)="onItemSelected($event)"
              [dataSource]="libraryTreeData"
              [template]="treeItem"
              data-cy="organizer-restore-library-tree">
              <ng-template #treeItem let-item>
                <div style="display: flex; cursor: pointer; font-size: 14px;" data-cy="organizer-restore-tree-item">
                  @if (item.matIconOverride) {
                    <lucide-icon name="trash-2" [size]="20" style="color: var(--tdo-secondary); transform: scale(1.5, 1.5); position: relative; top: 3px; left: 3px;" data-cy="organizer-restore-delete-icon"></lucide-icon>
                  }
                  @if (!item.matIconOverride) {
                    @if (!item.isExpanded) {
                      <div style="flex-basis: 36px;" data-cy="organizer-restore-folder-closed">
                        <img style="width: 90%; margin-top: 4px; margin-right: 6px;"
                          src="../../../../assets/Images/image-organizer/folder-closed.svg"
                          data-cy="organizer-restore-folder-closed-image">
                        </div>
                      }
                      @if (item.isExpanded) {
                        <div style="flex-basis: 36px;" data-cy="organizer-restore-folder-open">
                          <img style="width: 100%; margin-right: 6px; margin-top: 5px;"
                            src="../../../../assets/Images/image-organizer/folder-open.svg"
                            data-cy="organizer-restore-folder-open-image">
                          </div>
                        }
                      }
                      <!--                  <div style="flex-basis: 31px; margin-top: 5px; margin-left: 5px;" *ngIf="item.children.length == 0"><mat-icon><span class="material-icons-outlined">arrow_forward_ios</span></mat-icon></div>-->
                      <div style="flex: 1; margin-top: 7px; margin-left: 3px;"
                        [ngClass]="{'selected-item': isItemSelected(item)}"
                      data-cy="organizer-restore-item-name">{{item.name}}</div>
                    </div>
                  </ng-template>
                </tdo-tree>
              }
            </div>
          </div>
          <div style="height: 100%; flex-basis: 1px; background-color: var(--tdo-primary);" data-cy="organizer-restore-divider"></div>
          <div style="height: 100%; max-height: 100%; width: 100%; overflow-y: auto; overflow-x: hidden; padding-left: 10px; display: flex; flex-direction: column;" data-cy="organizer-restore-lecture-section">
            <span style="color: var(--tdo-primary); font-size: 22px;" data-cy="organizer-restore-lecture-label">Lecture</span>
            <div style="flex: 1; overflow-y: auto;" data-cy="organizer-restore-lecture-tree-container">
              @if (lectureTreeData.length > 0) {
                <tdo-tree
                  (itemSelected)="onItemSelected($event)"
                  [dataSource]="lectureTreeData"
                  [template]="treeItem2"
                  data-cy="organizer-restore-lecture-tree">
                  <ng-template #treeItem2 let-item>
                    <div style="display: flex; cursor: pointer; font-size: 14px;" data-cy="organizer-restore-tree-item">
                      @if (item.matIconOverride) {
                        <lucide-icon name="trash-2" [size]="20" style="color: var(--tdo-secondary); transform: scale(1.5, 1.5); position: relative; top: 3px; left: 3px;" data-cy="organizer-restore-delete-icon"></lucide-icon>
                      }
                      @if (!item.matIconOverride) {
                        @if (!item.isExpanded) {
                          <div style="flex-basis: 36px;" data-cy="organizer-restore-folder-closed">
                            <img style="width: 90%; margin-top: 4px; margin-right: 6px;"
                              src="../../../../assets/Images/image-organizer/folder-closed.svg"
                              data-cy="organizer-restore-folder-closed-image">
                            </div>
                          }
                          @if (item.isExpanded) {
                            <div style="flex-basis: 36px;" data-cy="organizer-restore-folder-open">
                              <img style="width: 100%; margin-right: 6px; margin-top: 5px;"
                                src="../../../../assets/Images/image-organizer/folder-open.svg"
                                data-cy="organizer-restore-folder-open-image">
                              </div>
                            }
                          }
                          <!--                  <div style="flex-basis: 31px; margin-top: 5px; margin-left: 5px;" *ngIf="item.children.length == 0"><mat-icon><span class="material-icons-outlined">arrow_forward_ios</span></mat-icon></div>-->
                          <div style="flex: 1; margin-top: 7px; margin-left: 3px;"
                            [ngClass]="{'selected-item': isItemSelected(item)}"
                          data-cy="organizer-restore-item-name">{{item.name}}</div>
                        </div>
                      </ng-template>
                    </tdo-tree>
                  }
                </div>
              </div>
            </div>
            <!--  FOOTER-->
            <div class="section-footer" style="flex-basis: 60px; padding-top: 10px;" data-cy="organizer-restore-footer">
              <div style="flex: 1; margin-right: 6px;"></div>
              <button (click)="onCancelClick()" class="tdo-button tdo-close" style="margin-right: 6px;" data-cy="organizer-restore-cancel-button">Cancel</button>
              <button (click)="onOkClick()" class="tdo-button tdo-save" style="margin-right: 6px;" data-cy="organizer-restore-ok-button">Ok</button>
            </div>
          </div>
        </div>
